import Tracker from './Tracker';
import { labelEvents } from './FileBrowser';

const MailTemplateTracker = new Tracker('MailTemplate', {
	...labelEvents,
	CREATED: 'created'
});

export default MailTemplateTracker;
